import { FactoryProvider } from '@angular/core';

import { AjsVendorQuickAddModel } from './typings/vendors.ajs-quick-add';

export const AJS_VENDOR = 'ajsVendor';

// The AngularJS quick-add supplier window, for converted screens that must keep it until it converts.
export const AJS_VENDOR_PROVIDER : FactoryProvider = {
  deps      : [ '$injector' ],
  provide   : AJS_VENDOR,
  useFactory: ( $injector : ng.auto.IInjectorService ) : AjsVendorQuickAddModel => $injector.get('Vendor')
};
